<template>
  <div class="row w-100">
    <div class="card w-100">
      <div class="card-header">
        <div class="w-100 d-flex justify-content-between">
          <h5>#{{ doubt.id }} - {{ doubt.user.name }} ( {{ doubt.course.name }} - {{ doubt.leason.name }} )</h5>
          <div>
            <button
              class="btn btn-sm btn-primary"
              type="button"
              data-toggle="collapse"
              :data-target="`#doubt-${ doubt.id }`"
              aria-expanded="false"
              :aria-controls="`doubt-${ doubt.id }`"
            >
              <i class="fa fa-plus-circle"></i>
            </button>
          </div>
        </div>
      </div>
      <div :id="`doubt-${ doubt.id }`" class="card-body col-12 collapse">
        <div class="row">
          <div class="w-100 d-flex justify-content-between mb-3">
            <div class="col-12 col-md-2 border-bottom">
              <small><b>Criado em:</b></small>
              <p class="mb-0">{{ doubt.created_at }}</p>
            </div>

            <div v-if="doubt.answer != undefined" class="col-12 col-md-2 border-bottom">
              <small><b>Respondida em</b></small>
              <p class="mb-0">{{ doubt.updated_at }}</p>
            </div>
          </div>

          <h5 class="col-12">Aluno</h5>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>ID</b></small>
            <p class="mb-0">{{ doubt.user.id }}</p>
          </div>
          <div class="col-12 col-md-4 border-bottom">
            <small><b>Nome</b></small>
            <p class="mb-0">{{ doubt.user.name }}</p>
          </div>
          <div class="col-12 col-md-4 border-bottom">
            <small><b>Email</b></small>
            <p class="mb-0">{{ doubt.user.email }}</p>
          </div>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>CPF/CNPJ</b></small>
            <p class="mb-0">{{ doubt.user.document }}</p>
          </div>

          <h5 class="col-12 mt-4">Professor</h5>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>ID</b></small>
            <p class="mb-0">{{ doubt.course.user.id }}</p>
          </div>
          <div class="col-12 col-md-4 border-bottom">
            <small><b>Nome</b></small>
            <p class="mb-0">{{ doubt.course.user.name }}</p>
          </div>
          <div class="col-12 col-md-4 border-bottom">
            <small><b>Email</b></small>
            <p class="mb-0">{{ doubt.course.user.email }}</p>
          </div>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>CPF/CNPJ</b></small>
            <p class="mb-0">{{ doubt.course.user.document }}</p>
          </div>

          <h5 class="col-12 mt-4">Pergunta</h5>
          <div class="col-12 border-bottom">
            <p class="mb-0">{{ doubt.ask }}</p>
          </div>

          <h5 class="col-12 mt-4">Resposta</h5>
          <div class="col-12 border-bottom">
            <p class="mb-0">{{ doubt.answer }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  props: {
    doubt: {
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    statuToTxt: function (item) {
      switch (item) {
        case 'P':
          return 'Processando';
        case 'W':
          return 'Esperado';
        case 'S':
          return 'Aprovado';
        case 'E':
          return 'Erro';
        default:
          break;
      }
    },
    saveAccessibility: function () {
      this.loading = true
      Axios.post('/teacher/my/courses/sells/change', {
        id: this.sell.id,
        is_accessable: this.sell.is_accessable
      })
        .then( res => {
          console.log( res )
        })
        .catch( err => {
          console.error( err )
        })
        .then( () => {
          this.loading = false
        })
    }
  }
}
</script>
